// Daniel Jackson
// Copyright 1994 and 2021

class Point4D {
  constructor(x, y, z, w) {
    this.x = x || 0;
    this.y = y || 0;
    this.z = z || 0;
    this.w = w || 0;
  }

  mult(f) {
    this.x *= f;
    this.y *= f;
    this.z *= f;
    this.w *= f;
  }
}

export { Point4D };
